import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Spinner, Button, useToast, HStack, Badge, Heading } from "@chakra-ui/react";
import GRLCPlacementEditor from "./GRLCPlacementEditor";
import Navbar from "./Navbar";

const GRLCPlacementEditorPage = () => {
  const { productCode, contractId } = useParams();
  const [contract, setContract] = useState(null);
  const [loading, setLoading] = useState(true);
  const toast = useToast();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchContract = async () => {
      try {
        const res = await fetch(`https://poc.mrc.ai/${productCode}/api/contracts/${contractId}`);
        const data = await res.json();
        setContract(data);
      } catch (err) {
        toast({ title: "Failed to load contract", status: "error" });
      } finally {
        setLoading(false);
      }
    };
    fetchContract();
  }, [productCode, contractId, toast]);

  if (loading) return <Spinner size="xl" />;

  return (
    <Box position="relative" width="100%" minHeight="100vh">
      <Navbar />

      {/* Version indicator and switch */}
      <Box p={4} bg="gray.50" borderBottom="1px" borderColor="gray.200">
        <HStack justify="space-between">
          <HStack>
            <Badge colorScheme="gray" fontSize="md" px={3} py={1}>
              Original Version
            </Badge>
            <Heading size="sm" color="gray.700">
              8,434 lines • Single file
            </Heading>
          </HStack>
          <Button
            size="sm"
            colorScheme="blue"
            onClick={() => navigate(`/product/${productCode}/contract/${contractId}/placement-v2`)}
          >
            Try Refactored Version →
          </Button>
        </HStack>
      </Box>

      <GRLCPlacementEditor contractInstance={contract} productTemplate={null}/>

    </Box>
  );
};

export default GRLCPlacementEditorPage;
